import {Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {CertificadoService} from "../shared/service/certificado/certificado.service";
import { UtilService } from '../shared/service/util/util.service';
import {EtokenParaVoceComponent} from "./etoken-para-voce/etoken-para-voce.component";
import {EtokenTerceirosComponent} from "./etoken-terceiros/etoken-terceiros.component";
import {TokenService} from "../shared/service/token/token.service"
import {EToken} from "../shared/model/etoken";
import { MatTableDataSource } from '@angular/material';
import { Usuario } from '../shared';


declare var $: any;

@Component({
  selector: 'app-etoken',
  templateUrl: './etoken.component.html',
  styleUrls: ['./etoken.component.css']
})
export class EtokenComponent implements OnInit {

  public statusFatores: any = {};
  public usuario : Usuario;
  public etoken : EToken;
  public currentEmailTerceiro : string = "";
  private listaETokensParaVoce: EtokenParaVoceComponent;
  private listETokensTerceiro: EtokenTerceirosComponent;
  private maxParaVoceEToken : number = 5;
  private maxParaTerceirosEToken : number = 5;
  public currentPin : string = "";

  @ViewChild('formETokenDelegado', { static: true }) formETokenDelegado;
  @ViewChild('painelETokenParaVoce', { read: ViewContainerRef, static: true }) painelETokenParaVoce: ViewContainerRef;
  @ViewChild('painelETokenTerceiros', { read: ViewContainerRef, static: true }) painelETokenTerceiros: ViewContainerRef;
  @ViewChild('modalCadastrarTokenComponent', {static: true}) modalCadastrarTokenComponent;

  public errorMessageDeletarToken : string;

  constructor(private certificadoService : CertificadoService
    , private factoryResolver : ComponentFactoryResolver
    , private utilService: UtilService
    , private tokenService:TokenService) {
  }

  ngOnInit() {
    this.usuario = JSON.parse(localStorage.getItem("currentUser"));
    this.buscaStatusFatores();
    this.inicializaViewETokensParaVoce();
    this.inicializaViewETokensTerceiros();
    this.reloadListETokens();
  }

  buscaStatusFatores() {
    let idUsuario =  this.usuario.id;
    let idOrganizacao = this.usuario.organizacaoId;

    this.certificadoService.getStatusFatores(idUsuario, idOrganizacao).subscribe(
      res => {
        this.statusFatores = res;
        this.maxParaTerceirosEToken = this.statusFatores.maxNumberETokenParaTerceiros;
        this.maxParaVoceEToken = this.statusFatores.maxNumberETokenParaVoce;
      }
    );
  }

  inicializaViewETokensParaVoce(){

    let factory = this.factoryResolver.resolveComponentFactory(EtokenParaVoceComponent);
    let component = factory.create(this.painelETokenParaVoce.parentInjector);
    this.listaETokensParaVoce = component.instance;
    this.listaETokensParaVoce.eventoNovoEToken.subscribe((numberOfETokens) =>{
      if(numberOfETokens>=this.maxParaVoceEToken){
        this.utilService.showError("Número máximo de e-Tokens permitidos: "+this.maxParaVoceEToken);
      }else{
        this.abrirJanelaRequisicaoDeNovoEToken();
      }
    });

    this.listaETokensParaVoce.eventoExcluirEToken.subscribe(
      (res) => {
        this.etoken = res;
        $('#modalDeletarToken').modal('show');
      }
    );

    //listaETokensParaVoce.
    this.painelETokenParaVoce.insert(component.hostView);


  }

  inicializaViewETokensTerceiros(){
    let factory = this.factoryResolver.resolveComponentFactory(EtokenTerceirosComponent);
    let component = factory.create(this.painelETokenTerceiros.parentInjector);
    this.listETokensTerceiro = component.instance;
    this.listETokensTerceiro.eventoNovoEToken.subscribe((numberOfETokens) =>{
      if(numberOfETokens>=this.maxParaTerceirosEToken){
        this.utilService.showError("Número máximo de e-Tokens permitidos: "+this.maxParaTerceirosEToken);
      }else{
        $('#modalAdicionarETokenTerceiros').modal('show');
      }
    });

    this.listETokensTerceiro.eventoExcluirEToken.subscribe((res) => {
      this.etoken = res;
      $('#modalDeletarToken').modal('show');
    });

    this.painelETokenTerceiros.insert(component.hostView)
  }


  reloadListETokens(){
    this.tokenService.obterListETokens(this.usuario.id,this.usuario.organizacaoId).subscribe(
      res => {
        var paraVoceETokenList : EToken[] = [];
        var paraTerceirosETokenList : EToken[] = [];
        res.forEach(etoken =>{
          if(etoken.tipo=="TERCEIRO"){
            paraTerceirosETokenList.push(etoken)
          }else{
            paraVoceETokenList.push(etoken)
          }
        });

        this.listaETokensParaVoce.dataSource = new MatTableDataSource(paraVoceETokenList);
        this.listETokensTerceiro.dataSource = new MatTableDataSource(paraTerceirosETokenList);
      }
    )
  }

  eTokenCadastrado(){
    this.buscaStatusFatores();
    this.reloadListETokens();
    //this.acessaTour = false;
  }

  abrirJanelaRequisicaoDeNovoEToken(){

    $('#modalCadastrarToken').modal('show');
  }

  resetFormDeletarToken(){
    //metodo criado para ser usado no futuro.
  }

  resetFormAdicinarETokenTerceiros(){
    //metodo criado para ser usado no futuro.
  }

  resetFormAdicinarETokenTerceirosPedirPin(){
    this.formETokenDelegado.resetForm();
  }

  pedirPinEConfirmarEmail(){
    $('#modalAdicionarETokenPedirPinTerceiro').modal('show');
  }

  inicializacaoETokenTerceirosFase1(){
    this.tokenService.inicializacaoETokenTerceirosFase1(this.usuario.id,this.usuario.organizacaoId,this.currentPin,this.currentEmailTerceiro).subscribe(res => {
        $("#modalAdicionarETokenPedirPinTerceiro").modal("hide");
        $("#modalcadastroETokenTerceirosFase1Terminado").modal("show");
        this.resetFormAdicinarETokenTerceirosPedirPin();
        this.reloadListETokens();
      },
      err => {
        this.utilService.showError(err.message);
      });
  }

  confirmFormDeletarToken(){
    this.tokenService.deletaEToken(this.usuario.id,this.etoken.id).subscribe(res => {
      this.utilService.showSuccess("e-Token excluído");
        this.reloadListETokens();
      },
      err => {
        this.utilService.showError(err.message);
      });
  }

  recebeMensagemSucesso(mensagem){
    this.utilService.showSuccess(mensagem);
  }  
}